import axios from "../../plugins/axios";
import utils from "../../../utils/utils2"; //utils中已经import了user，为了防止彼此引用问题，新做的一个utils


// 用户模块api
class User {
    // class内部是严格模式，this指向的是underfined，所以找不到类中的方法
    constructor() {
        let resolve = () => {
            console.log('this', this)
        }
        resolve()
    }
    //--------------AD用户---------------//
    // INTF-00106：新增AD的dn
    addDn(body) {
        return axios.post(`/myUserApp/service.AdProvider/CreateOne`, body)
    }

    // INTF-00107：查询所有AD的dn
    async getAllDn(body) {
        try {
            let res = await axios.post(`/myUserApp/service.ad.AdProvider/FindAll`, body);
            //判断是否空对象
            let check = utils.isEmptyObject(res);
            if (check) {
                //空对象，补充
                res.dn_list = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get dn list failed: INTF-00107", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00108：查询AD中的所有用户
    async getAllAdUser(body) {
        try {
            let res = await axios.post(`/myUserApp/service.ad.AdProvider/Refresh`, body);
            let check = utils.isEmptyObject(res);
            if (check) {
                //空对象，重新包装
                res.adusers = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get all ad user failed", err);
            return { err: true, msg: err.response.data };
        }
    }

    //--------------该系统用户---------------//
    // INTF-00096：登陆
    async login(body) {
        try {
            let res = await axios.post(`/myUserApp/service.user.UserProvider/Login`, body);
            //把uid转成数值型
            res.uid = Number(res.uid);
            return res;
        } catch (err) {
            console.log("Login failed: INTF-00096");
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00097：登出
    logout() {
        let body = {};
        return axios.post(`/myUserApp/service.user.UserProvider/Logout`, body);
    }

    // INTF-00120：单个用户导入
    addUserByAd(body) {
        return axios.post(`/myUserApp/service.user.UserProvider/CreateOne`, body)
    }


    //INTF-00784:获取用户当前所在的公司
    getCurrentCompanyByUser(){
        let body={};
        return axios.post(`/myUserApp/service.user.UserProvider/GetCurrentCompany`,body);
    }

    //------------用户列表操作------------------//
    //INTF-00098：查询获取用户列表信息
    async getUserList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myUserApp/service.user.UserProvider/FindAll`, body);
            //判断res是否空对象
            let check = utils.isEmptyObject(res);
            if (check) {
                //空对象，重新包装
                res.userInfos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get user list failed: INTF-00098", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00099：根据ID获取用户信息
    async getUserInfoById(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myUserApp/service.user.UserProvider/FindOne`, body);
            //判断并补充default_company_id, companies属性
            if (res.default_company_id === undefined) {
                res.default_company_id = 0;
            }
            if (res.companies === undefined) {
                res.companies = [];
            }
            return res;
        } catch (err) {
            console.log("get user info failed: INTF-00099");
            return { err: true, msg: err.response.data };
        }
    }


    //INTF-00110：用户的批量禁用/启用
    batchUserEnableOrDisable(body) {
        return axios.post(`/myUserApp/service.user.UserProvider/UpdateActived`, body);
    }

    //INTF-00100：修改更新一条用户基础信息
    updateOneDetail(val) {
        let body = val;
        return axios.post(`/myUserApp/service.user.UserProvider/UpdateOneDetail`, body);
    }

    //INTF-00324：获取不分页的用户信息
    async getUserListNoPages() {
        let body = {};
        try {
            let res = await axios.post(`/myUserApp/service.user.UserProvider/FindAllNoLimit`, body);
            let check = utils.isEmptyObject(res);
            if (check) {
                //空对象，补全
                res.total = 0;
                res.userInfos = [];
            }
            return res;
        } catch (err) {
            console.log("get user list no pages failed: INTF-00324", err);
            return { err: true, msg: err.response.data };
        }
    }

    //-----------获取用户的菜单权限--------------//
    //INTF-00109:根据用户id获取用户的菜单权限
    async getMenuAuthority(uid) {
        let body = { id: uid };
        try {
            let res = await axios.post(`/myUserApp/service.user.UserProvider/GetMenulist`, body);
            //检查是不是没有菜单权限
            if (res.module_infos === undefined) {
                //没有菜单模块权限，补全属性
                res.module_infos = [];
            }
            return res;
        } catch (err) {
            console.log("get user menu authority failed: INTF-00109", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00395:根据供应商用户id获取菜单权限
    async getSupMenuAuthority(id) {
        let body = { id: id };
        try {
            let res = axios.post(`/myUserApp/service.user.UserProvider/GetSupplierMenulist`, body);
            if (res.module_infos === undefined) {
                //补全
                res.module_infos = [];
            }
            return res;
        } catch (err) {
            console.log("get supplier menu authority failed: INTF-00395", err);
            return { err: true, msg: err.response.data };
        }
    }


    //----------角色模块相关接口----------------------//

    //INTF-00101：创建新增角色
    addRole(body) {
        return axios.post(`/myUserApp/service.role.RoleProvider/CreateOne`, body);
    }


    //INTF-00102: 修改角色的信息及权限
    updateRole(body) {
        return axios.post(`/myUserApp/service.role.RoleProvider/UpdateOneDetail`, body);
    }

    //INTF-00103：查询角色列表
    async getRoleList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myUserApp/service.role.RoleProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.role_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get role list in pages failed: INTF-00103", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00104：在角色下查询用户
    async getUsersByRole(role_id) {
        let body = { id: role_id };
        try {
            let res = await axios.post(`/myUserApp/service.role.RoleProvider/ShowUsers`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.userInfos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get user list by role failed: INTF-00104", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00105：某个角色id下的菜单权限信息。
    async getMenuListByRoleId(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myUserApp/service.role.RoleProvider/ShowMenus`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.menu_details = [];
            }
            return res;
        } catch (err) {
            console.log("get menu list by role failed: INTF-00105", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00112：在角色下添加用户
    increaseUsers(role_id, arr) {
        let body = { role_id: role_id, uid: arr };
        return axios.post(`/myUserApp/service.role.RoleProvider/IncreaseUsers`, body);
    }

    //INTF-00113：在角色下移除用户
    decreaseUsers(id, arr) {
        let body = { role_id: id, uid: arr };
        return axios.post(`/myUserApp/service.role.RoleProvider/DecreaseUsers`, body);
    }

    //INTF-00114：角色的启用、禁用
    batchRoleEnableOrDisable(arr, x) {
        let body = { id_arr: arr, if_actived: x }
        return axios.post(`/myUserApp/service.role.RoleProvider/UpdateActived`, body);
    }


    //INTF-00115：查询不在角色下的用户列表，分页
    async usersOutOfTheRole(body) {
        try {
            let res = await axios.post(`/myUserApp/service.role.RoleProvider/OutOfTheRole`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.userInfos = [];
                res.total - 0;
            }
            return res;
        } catch (err) {
            console.log("get users out of the role failed: INTF-00115", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00117：获取所有的模块菜单列表
    async getAllMenus() {
        let body = {};
        try {
            let res = await axios.post(`/myUserApp/service.role.RoleProvider/AllMenus`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.menu_details = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get all menus failed: INTF-00117", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00119：获取用户下的角色
    async getRoleByUser(uid) {
        let body = { id: uid };
        try {
            let res = await axios.post(`/myUserApp/service.user.UserProvider/ShowRoles`, body);
            let check = utils.isEmptyObject(res);
            if (check) {
                //空对象，补全
                res.role_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get role list by user failed: INTF-00119", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00121：在用户下添加角色
    increaseRoles(uid, role_id) {
        let body = { uid: uid, role_id: role_id };
        return axios.post(`/myUserApp/service.user.UserProvider/IncreaseRoles`, body);
    }

    //INTF-00122：从用户下移除角色
    decreaseRoles(uid, role_id) {
        let body = { uid: uid, role_id: role_id }
        return axios.post(`/myUserApp/service.user.UserProvider/DecreaseRoles`, body);
    }


    //INTF-00123：获取不在用户下的角色列表
    async getRoleNotInUser(body) {
        try {
            let res = await axios.post(`/myUserApp/service.user.UserProvider/OutOfTheUser`, body);
            let check = utils.isEmptyObject(res);
            if (check) {
                //空对象，补全
                res.total = 0;
                res.role_infos = [];
            }
            return res;
        } catch (err) {
            console.log("get role list not in user failed: INTF-00123", err);
            return { err: true, msg: err.response.data };
        }
    }


    //------------------------用户当前登录的公司相关---------------//
    //INTF-00576：用户在登陆状态中，进行公司的的切换.
    changeCurrentCompany(id) {
        let body = { id: id };
        return axios.post(`/myUserApp/service.user.UserProvider/ChangeCompany`, body);
    }


    //-----------------------权限转移--------------------------//
    //INTF-00687：查询某个用户有数据的列表信息
    async getDataTypeListByUid(uid) {
        let body = { id: uid };
        try {
            let res = await axios.post(`/myUserApp/service.user.UserProvider/FindModelsByUser`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.own_model = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get data type list by uid failed: INTF-00687", err);
            return { err: true, msg: response.data };
        }
    }

    //INTF-00688：设置对象数据的权限转移
    transferOwner(val) {
        let body = val;
        return axios.post(`/myUserApp/service.user.UserProvider/UpdateOwner`, body);
    }

}

export default User;